import React, { useState } from 'react';
import { Bot, Users, UserCog, LogOut, ChevronRight } from 'lucide-react';

const Sidebar = ({ activePage, onPageChange }) => {
  const [expanded, setExpanded] = useState(false);

  const menuItems = [
    { icon: <Bot className="w-5 h-5 flex-shrink-0" />, label: 'Dashboard', id: 'dashboard' },
    { icon: <Users className="w-5 h-5 flex-shrink-0" />, label: 'CRM', id: 'crm' },
    { icon: <UserCog className="w-5 h-5 flex-shrink-0" />, label: 'Settings', id: 'settings' },
    { icon: <LogOut className="w-5 h-5 flex-shrink-0" />, label: 'Log off', id: 'logoff' },
  ];

  return (
    <aside
      style={{
        width: expanded ? '220px' : '68px',
        transition: 'width 220ms cubic-bezier(0.4, 0, 0.2, 1)',
        minWidth: expanded ? '220px' : '68px',
      }}
      className="h-screen bg-[#0e0e0e] border-r border-[#1e1e1e] flex flex-col py-5 overflow-hidden relative z-20 flex-shrink-0"
    >
      {/* Logo */}
      <div className="px-3 mb-7 flex items-center" style={{ minHeight: '40px' }}>
        {expanded ? (
          <span
            className="text-lg font-semibold tracking-[0.18em] text-white"
            style={{ opacity: 1, transition: 'opacity 150ms ease 80ms' }}
          >
            BUNKER
          </span>
        ) : (
          <div className="w-9 h-9 flex-shrink-0 mx-auto flex items-center justify-center">
            <span
              aria-label="Bunker"
              className="w-9 h-9 rounded-lg border border-[#2a2a2a] bg-[#161616] text-[#F59E0B] flex items-center justify-center text-lg font-semibold"
            >
              B
            </span>
          </div>
        )}
      </div>

      {/* Nav items */}
      <nav className="flex flex-col gap-1 flex-1 px-2 overflow-y-auto overflow-x-hidden">
        {menuItems.map((item) => {
          const isActive = activePage === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onPageChange(item.id)}
              title={expanded ? undefined : item.label}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
              className={[
                'group relative flex items-center gap-3 rounded-xl cursor-pointer text-left',
                'transition-colors duration-150 outline-none focus-visible:ring-2 focus-visible:ring-white/20',
                expanded ? 'px-3 py-2.5' : 'px-0 py-2.5 justify-center',
                isActive
                  ? 'bg-[#1C1400] text-[#e8e8e8]'
                  : 'text-[#555] hover:bg-[#181818] hover:text-[#aaa]',
              ].join(' ')}
              style={{ minWidth: 0 }}
            >
              {/* Active left bar */}
              {isActive && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-[#F59E0B] rounded-r-full" />
              )}

              <span className={isActive ? 'text-[#F59E0B]' : ''}>
                {item.icon}
              </span>

              {expanded && (
                <span
                  className="text-sm font-medium whitespace-nowrap overflow-hidden"
                  style={{
                    fontFamily: "'Jost', system-ui, sans-serif",
                    letterSpacing: '0.02em',
                    opacity: expanded ? 1 : 0,
                    transition: 'opacity 120ms ease',
                  }}
                >
                  {item.label}
                </span>
              )}

              {/* Tooltip when collapsed */}
              {!expanded && (
                <span className="pointer-events-none absolute left-full ml-3 px-2.5 py-1.5 bg-[#1e1e1e] border border-[#2a2a2a] text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 whitespace-nowrap z-50 shadow-xl">
                  {item.label}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Toggle button */}
      <div className="px-2 pt-3 border-t border-[#1e1e1e] mt-2">
        <button
          onClick={() => setExpanded(e => !e)}
          className="w-full flex items-center justify-center py-2.5 rounded-xl text-[#444] hover:text-[#888] hover:bg-[#181818] transition-colors duration-150 cursor-pointer"
          title={expanded ? 'Collapse' : 'Expand'}
        >
          <ChevronRight
            className="w-4 h-4 transition-transform duration-220"
            style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          />
        </button>
      </div>
    </aside>
  );
};

export default React.memo(Sidebar);
